export default __webpack_public_path__ + "static/media/bg4.befb762c.png";